import * as React from 'react';

import { RemoteConfigKey, RemoteConfigValueOf } from '../../config/remote-config.config';
import {
  getRemoteConfigStatus,
  getRemoteSnapshot,
  subscribeRemoteConfig
} from '../../services/utils/remote-config/remote-config.service';

/**
 * Starts on the default, then re-renders whenever a newly fetched value
 * differs. Use `isResolved` to hold off rendering when the swap would be
 * visible.
 *
 * React 17 has no useSyncExternalStore, so this subscribes by hand.
 */
export default function useRemoteValue<K extends RemoteConfigKey>(key: K) {
  const [value, setValue] = React.useState<RemoteConfigValueOf<K>>(() => getRemoteSnapshot(key));
  const [isResolved, setIsResolved] = React.useState(
    () => getRemoteConfigStatus().status !== 'idle'
  );

  React.useEffect(() => {
    const sync = () => {
      setValue(getRemoteSnapshot(key));
      setIsResolved(getRemoteConfigStatus().status !== 'idle');
    };

    const unsubscribe = subscribeRemoteConfig(sync);
    sync();

    return unsubscribe;
  }, [key]);

  return { value, isResolved };
}
